<template>
  <div>
    <h2
      class="mb-2 inline-flex items-center rounded-full bg-lime-200 px-3 py-1 text-sm font-semibold leading-normal text-lime-900"
    >
      {{ heading }}
    </h2>
    <slot />
  </div>
</template>
<script setup lang="ts">
const { heading } = defineProps<{
  heading: string
}>()
</script>
